// Basic
import { useState } from 'react';
import PropTypes from 'prop-types';
// Store & actions
import actionsOrganizations from '../../../api/actionsOrganizations';
// Components
import { Modal, ModalContent, ModalBody } from '@/common-utils/components/ui/modal';
import HeaderTitle from '@/common-utils/components/renders/modal/components/headers/HeaderTitle/HeaderTitle';
import FooterForm from '@/common-utils/components/renders/modal/components/footers/FooterForm/FooterForm';
import FormAddPort from './FormAddPort';
import Entity from '@/common-utils/components/renders/entity/Entity';
// Common
import { useToast } from '@/common-utils/hooks/use-toast';
// Lang
import { nsOrganization } from '@/app/i18n/namespaces';

/**
 * Modal to add a port to an organization.
 * @param {boolean} isOpen - Whether the modal is open.
 * @param {function} setIsOpen - Function to set the modal open state.
 * @param {string} organizationId - Organization uuid.
 * @param {function} setLaunchRefetch - Function to trigger organization refetch.
 * @returns {JSX.Element} ModalAddPort
 */
function ModalAddPort({ isOpen, setIsOpen, organizationId, setLaunchRefetch }) {
    // Toast
    const { toast } = useToast();

    // State
    const [portFormData, setPortFormData] = useState({ data: {}, isValid: false });

    // Api calls
    const onSuccess = () => {
        setIsOpen(false);
        setLaunchRefetch(true);
        toast({
            description: <Entity entity='modal.add_port.success' namespace={nsOrganization} />,
            variant: 'success'
        });
    };
    const onError = () => {
        setIsOpen(false);
        toast({
            description: <Entity entity='modal.add_port.error' namespace={nsOrganization} />,
            variant: 'danger'
        });
    };
    const createOrganizationPort = actionsOrganizations.createOrganizationPort(onSuccess, onError);

    return (
        <Modal open={isOpen} onOpenChange={setIsOpen}>
            <ModalContent className='max-w-xl'>
                <HeaderTitle title='modal.add_port.title' namespace={nsOrganization} />
                <ModalBody>
                    <FormAddPort setPortFormData={setPortFormData} />
                </ModalBody>
                <FooterForm
                    onSubmit={() => {
                        createOrganizationPort.mutate({
                            uuid: organizationId,
                            portData: portFormData.data
                        });
                    }}
                    isSubmitting={createOrganizationPort.isLoading}
                    isSubmitDisabled={!portFormData.isValid}
                />
            </ModalContent>
        </Modal>
    );
}

ModalAddPort.propTypes = {
    isOpen: PropTypes.bool.isRequired,
    setIsOpen: PropTypes.func.isRequired,
    organizationId: PropTypes.string.isRequired,
    setLaunchRefetch: PropTypes.func.isRequired
};

export default ModalAddPort;